import i18n from 'i18next';
import type { ResourceLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import { DEFAULT_LOCALE } from '../constants';

import enUS from '../../../../locales/en-US.json';
import enAU from '../../../../locales/en-AU.json';
import enCA from '../../../../locales/en-CA.json';
import enGB from '../../../../locales/en-GB.json';
import esMX from '../../../../locales/es-MX.json';
import frCA from '../../../../locales/fr-CA.json';
import jaJP from '../../../../locales/ja-JP.json';
import thTH from '../../../../locales/th-TH.json';
import zhHK from '../../../../locales/zh-HK.json';
import msMY from '../../../../locales/ms-MY.json';
import idID from '../../../../locales/id-ID.json';
import viVN from '../../../../locales/vi-VN.json';

type Locales =
  | 'en-US'
  | 'en-AU'
  | 'en-CA'
  | 'en-GB'
  | 'es-MX'
  | 'fr-CA'
  | 'ja-JP'
  | 'th-TH'
  | 'zh-HK'
  | 'ms-MY'
  | 'id-ID'
  | 'vi-VN';

type LanguagesResources = {
  [language in Locales]: ResourceLanguage;
};

const resources: LanguagesResources = {
  'en-US': { translation: enUS },
  'en-AU': { translation: enAU },
  'en-CA': { translation: enCA },
  'en-GB': { translation: enGB },
  'es-MX': { translation: esMX },
  'fr-CA': { translation: frCA },
  'ja-JP': { translation: jaJP },
  'th-TH': { translation: thTH },
  'zh-HK': { translation: zhHK },
  'ms-MY': { translation: msMY },
  'id-ID': { translation: idID },
  'vi-VN': { translation: viVN },
};

i18n
  .use(initReactI18next)
  .use(ICU)
  .init({
    resources,
    lng: DEFAULT_LOCALE,
    returnEmptyString: false,
    fallbackLng: DEFAULT_LOCALE,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
